import { render } from "./HeaderTitle.vue?vue&type=template&id=ab000664"
import script from "./HeaderTitle.vue?vue&type=script&lang=js"
export * from "./HeaderTitle.vue?vue&type=script&lang=js"

import "./HeaderTitle.vue?vue&type=style&index=0&id=ab000664&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__